import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrganiserGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {

    const role = localStorage.getItem('Role');

    if (role === 'organiser') {
      return true;
    }

    return this.router.createUrlTree(['/admin/dashboard']);

  }

}